import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-04ca3238"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-patrol" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "巡查详情")
], -1))
const _hoisted_3 = { class: "body" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "ul" }
const _hoisted_6 = { class: "li" }
const _hoisted_7 = { class: "li-left" }
const _hoisted_8 = { class: "li-right" }
const _hoisted_9 = { class: "li" }
const _hoisted_10 = { class: "li-left" }
const _hoisted_11 = { class: "li-right" }
const _hoisted_12 = { class: "li" }
const _hoisted_13 = { class: "li-left" }
const _hoisted_14 = { class: "li-right" }
const _hoisted_15 = { class: "li" }
const _hoisted_16 = { class: "li-left" }
const _hoisted_17 = { class: "li-right" }
const _hoisted_18 = { class: "li" }
const _hoisted_19 = { class: "li-left" }
const _hoisted_20 = { class: "li-right" }
const _hoisted_21 = { class: "li" }
const _hoisted_22 = { class: "li-img" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 现场照片：", -1))
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "li" }
const _hoisted_26 = { class: "li-map" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 巡河详情：", -1))
const _hoisted_28 = {
  id: "xhxqMap",
  ref: "xhxqMap",
  class: "map"
}

import { toRefs, nextTick, getCurrentInstance, onMounted, h } from 'vue'
import { ref } from 'vue-demi'
import { Api } from '@/api/publicApi'
import { MapService } from '@/utils/mapServices2'

export default /*#__PURE__*/_defineComponent({
  __name: 'DialogPatrolDetails',
  props: {
  data: Object,
},
  setup(__props) {

const { proxy } = getCurrentInstance()
const props = __props
const record = ref({})
const api = new Api()
const mapService2 = new MapService()

const xhxqDialogData = ref({})

// 初始化地图
const initMap = () => {
  const center = [xhxqDialogData.value.qdjd, xhxqDialogData.value.qdwd]
  mapService2.initMap(
    {
      container: 'xhxqMap',
      style:
        'https://ychz.cqhtwl.com.cn/map_tile/wrpfyjs/public-all/htmap/yczhhz/mapbox/ht%E6%96%B0%E6%B2%B3%E9%95%BF%E5%A4%A7%E5%B1%8F-%E8%AF%A6%E6%83%85.json',
      center,
      zoom: 14.5,
      minZoom: 9,
    },
    'pk.eyJ1IjoiYWRpY292b2ZlciIsImEiOiJja3lvN2FhZWgyeGowMzFwbDB2M2Nod3o1In0.9XgOC6GgG65a_dNJnB5ksA'
  )
  drawLine()
}

const drawLine = () => {
  mapService2.map.once('load', () => {
    const data = [
      {
        coordinates: [xhxqDialogData.value.qdjd, xhxqDialogData.value.qdwd],
        properties: {
          name: xhxqDialogData.value.qdmc,
          icon: '起点.png',
        },
      },
      {
        coordinates: [xhxqDialogData.value.zdjd, xhxqDialogData.value.zdwd],
        properties: {
          name: xhxqDialogData.value.zdmc,
          icon: '终点.png',
        },
      },
    ]

    // 添加上报事件定位图标
    if (xhxqDialogData.value.sbsjs) {
      for (let i = 0; i < xhxqDialogData.value.sbsjs.length; i++) {
        data.push({
          coordinates: [xhxqDialogData.value.sbsjs[i].jd, xhxqDialogData.value.sbsjs[i].wd],
          properties: {
            name: xhxqDialogData.value.sbsjs[i].sjmc,
            icon: '超标报警.png',
          },
        })
      }
    }
    // drawTrajectory(//图层ID字符串自己随便传必须要有，// 轨迹的经纬度坐标为数组，包含轨迹多个点的经纬度，//线颜色(默认 #ffee00)，线宽(默认 8))
    mapService2.drawTrajectory('xhxqMap-1', xhxqDialogData.value.gjs, '#09CEA5', 4)
    mapService2.addPointsLayer('xhxqMapPosition', data, '', 0.9)
  })
}

onMounted(() => {
  api.screen.getWgyXhRecordDetailUsingGet({ id: props.data.id }).then((res) => {
    if (res.code === 200) {
      xhxqDialogData.value = res.data
      initMap()
    }
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createTextVNode(" 巡查范围："),
              _createElementVNode("span", null, _toDisplayString(_unref(xhxqDialogData).xcfw ? _unref(xhxqDialogData).xcfw : ''), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createTextVNode(" 流域名称："),
              _createElementVNode("span", null, _toDisplayString(_unref(xhxqDialogData).ly ? _unref(xhxqDialogData).ly : ''), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createTextVNode(" 巡查人员："),
              _createElementVNode("span", null, _toDisplayString(_unref(xhxqDialogData).zrrUserName ? _unref(xhxqDialogData).zrrUserName : ''), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createTextVNode(" 巡查频次："),
              _createElementVNode("span", null, _toDisplayString(_unref(xhxqDialogData).pc ? _unref(xhxqDialogData).pc : ''), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createTextVNode(" 开始时间："),
              _createElementVNode("span", null, _toDisplayString(_unref(xhxqDialogData).xhjssj ? _unref(xhxqDialogData).xhjssj : ''), 1)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createTextVNode(" 结束时间："),
              _createElementVNode("span", null, _toDisplayString(_unref(xhxqDialogData).xhkssj ? _unref(xhxqDialogData).xhkssj : ''), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createTextVNode(" 巡河距离："),
              _createElementVNode("span", null, _toDisplayString(_unref(xhxqDialogData).xhdx ? _unref(xhxqDialogData).xhdx.xcjl : ''), 1)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createTextVNode(" 联系方式："),
              _createElementVNode("span", null, _toDisplayString(_unref(xhxqDialogData).zrrUserTel ? _unref(xhxqDialogData).zrrUserTel : ''), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createTextVNode(" 网格编号："),
              _createElementVNode("span", null, _toDisplayString(_unref(xhxqDialogData).wgbh ? _unref(xhxqDialogData).wgbh : ''), 1)
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createTextVNode(" 巡河时长："),
              _createElementVNode("span", null, _toDisplayString(_unref(xhxqDialogData).xhdx ? _unref(xhxqDialogData).xhdx.xcsc : ''), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(xhxqDialogData).files, (item, index) => {
                return (_openBlock(), _createElementBlock("img", {
                  key: index,
                  src: item.url,
                  alt: ""
                }, null, 8, _hoisted_24))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createElementVNode("div", _hoisted_28, null, 512)
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})